import { render } from "./slide3.vue?vue&type=template&id=3693fdbc&scoped=true"
import script from "./slide3.vue?vue&type=script&lang=js"
export * from "./slide3.vue?vue&type=script&lang=js"

import "./slide3.vue?vue&type=style&index=0&id=3693fdbc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3693fdbc"]])

export default __exports__